// extracted by mini-css-extract-plugin
export default {"wrapper":"adminLogs_wrapper__c7w9X","number":"adminLogs_number__dTZpw","log":"adminLogs_log__XwPNe","logLine":"adminLogs_logLine__fw3f0","important":"adminLogs_important__7HZhd"};